import { render, staticRenderFns } from "./ModalVisualizarEmbargosInteligenciaTerritorial.vue?vue&type=template&id=70d1eb4d&lang=pug"
import script from "./ModalVisualizarEmbargosInteligenciaTerritorial.vue?vue&type=script&lang=js"
export * from "./ModalVisualizarEmbargosInteligenciaTerritorial.vue?vue&type=script&lang=js"
import style0 from "./ModalVisualizarEmbargosInteligenciaTerritorial.vue?vue&type=style&index=0&id=70d1eb4d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports